import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute'; // This is the original one for public users
import AboutPage from './pages/AboutPage';
import LandingPage from './pages/LandingPage';
import StartPlan from './pages/StartPlan';
import MyTravels from './pages/MyTravels';
import MyDreamList from './pages/MyDreamList';
import AchievementsPage from './pages/AchievementsPage';
import Expenditures from './pages/Expenditures';
import ProfilePage from './pages/ProfilePage';

import PlanResultPage from './pages/PlanResultPage';
import Settings from './pages/Settings';
import SettingsProfile from './pages/settings/SettingsProfile';
import SettingsNotifications from './pages/settings/SettingsNotifications';
import SettingsPrivacy from './pages/settings/SettingsPrivacy';
import SettingsLanguage from './pages/settings/SettingsLanguage';
import LoginLogout from './pages/login&logout';
import BlogPage from './pages/BlogPage';
import BlogDetailPage from './pages/BlogDetailPage'; // Import the new component
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';

// Admin Imports
import AdminLayout from './layouts/AdminLayout';
import LoginPage from './pages/admin/LoginPage';
import DashboardPage from './pages/admin/DashboardPage';
import AllContentPage from './pages/admin/AllContentPage';
import AddEditContentPage from './pages/admin/AddEditContentPage';
import MediaPage from './pages/admin/MediaPage';
import AdminProtectedRoute from './components/admin/ProtectedRoute';

const adminPath = process.env.REACT_APP_ADMIN_PATH || '/sh-yonetim-kapisi-x7';

function App() {
  return (
    <Routes>
      {/* Admin Routes */}
      <Route path={adminPath} element={<LoginPage />} />
      <Route
        path={adminPath}
        element={
          <AdminProtectedRoute>
            <AdminLayout />
          </AdminProtectedRoute>
        }
      >
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="all-content" element={<AllContentPage />} />
        <Route path="add-content" element={<AddEditContentPage />} />
        <Route path="edit-content/:id" element={<AddEditContentPage />} />
        <Route path="media" element={<MediaPage />} />
        {/* Add other admin routes here, e.g., settings */}
      </Route>

      {/* Public Site Routes */}
      <Route
        path="/*"
        element={
          <>
            <Navbar />
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/hakkimizda" element={<AboutPage />} />
              <Route path="/about" element={<Navigate to="/hakkimizda" replace />} />
              <Route path="/my-travels" element={<ProtectedRoute><MyTravels /></ProtectedRoute>} />
              <Route path="/my-dream-list" element={<ProtectedRoute><MyDreamList /></ProtectedRoute>} />
              <Route path="/achievements" element={<ProtectedRoute><AchievementsPage /></ProtectedRoute>} />
              <Route path="/expenditures" element={<ProtectedRoute><Expenditures /></ProtectedRoute>} />
              <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
              <Route path="/plan-result" element={<ProtectedRoute><PlanResultPage /></ProtectedRoute>} />
              <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
              <Route path="/settings/profile" element={<ProtectedRoute><SettingsProfile /></ProtectedRoute>} />
              <Route path="/settings/notifications" element={<ProtectedRoute><SettingsNotifications /></ProtectedRoute>} />
              <Route path="/settings/privacy" element={<ProtectedRoute><SettingsPrivacy /></ProtectedRoute>} />
              <Route path="/settings/language" element={<ProtectedRoute><SettingsLanguage /></ProtectedRoute>} />
              <Route path="/login" element={<LoginLogout />} />
              <Route path="/start-plan" element={<StartPlan />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:id" element={<BlogDetailPage />} />
            </Routes>
            <Footer />
          </>
        }
      />
    </Routes>
  );
}

export default App;